import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import cn from 'utils/classnames';

import styles from './AppLink.module.scss';

function AppLink(props) {
  const { href, className, children } = props;

  return (
    <Link to={href} className={cn(styles.Component, className)}>{children}</Link>
  );
}

AppLink.propTypes = {
  href: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Object)]).isRequired,
  className: PropTypes.string,

  children: PropTypes.node.isRequired,
};

AppLink.defaultProps = {
  className: '',
};

export default React.memo(AppLink);
